
import { message } from 'antd';
import axios from 'axios';
import { ROOT_PATH } from '../origin';
import emitter from './emitter';
import { md5sign } from './md5sign';
import { getDeviceId } from './device';
import { showLoading, hideLoading } from './loading';
import { CODE_PASSWORD_CHANGE_REQUIRED } from '../constant';

const { localStorage, location } = window;
const codeMap = {
  '-1': '服务器繁忙请稍后再试',
  402: '请求方式不支持',
  403: 'CURL请求失败',
  404: 'interface缺少方法',
  // 405: '参数错误',
  406: '操作失败',
  407: '非法操作',
  105000: '用户名不存在',
  105001: '密码错误',
  // 105002: '账户状态异常',
  105003: '路由已存在',
  105004: '角色已存在',
  105005: '手机号码已被占用',
  // 105006: '账户不存在',
  105007: '密码错误',
  105010: '没有操作权限',
  105011: '公司名称已被占用',
  105012: '业务员三方编号被占用',
};

const authError = {
  401: '验签失败',
  105008: '账户状态异常',
  105009: '请先登录',
  105002: '账户状态异常',
};

const Axios = axios.create({
  // baseURL: process.env.BASE_URL, // 设置请求的base url
  timeout: 600000, // 设置超时时长
});

Axios.interceptors.request.use(config => {
  config.params = md5sign(config.params);
  return config;
});

export default function send(value = {}) {
  const token = localStorage.getItem('token');
  const defaultHeader = { 'device-id': getDeviceId(), ...(token && { token }) };
  // const defaultHeader = { ...(token && { token }) };
  const { url, method = 'GET', data, params, options = {} } = value;
  const { loading = false } = options;
  const baseUrl = url.startsWith('http') ? url : `${ROOT_PATH}${url}`;
  loading && showLoading();
  return new Promise((resolve, reject) => {
    Axios({
      url: baseUrl,
      method,
      headers: defaultHeader,
      data,
      params,
    }).then(res => {
      const { data: { code }, data } = res;
      if (data && +code !== 0) {
        if (codeMap[code]) {
          message.error(codeMap[code], 1);
        } else if (authError[code]) {
          if (location.pathname) {
            localStorage.setItem('prePathName', location.pathname);
          }
          emitter.emit('authError');
        } else if (+code === CODE_PASSWORD_CHANGE_REQUIRED) {
          // 需要修改密码，不弹出错误提示，交由调用方处理
          resolve(res);
          return;
        } else {
          const { msg } = data;
          message.error(msg);
        }
        reject(code);
      } else {
        resolve(res);
      }
    }).finally(() => {
      loading && hideLoading();
    });
  });
}